import React from 'react';
import { Icon } from 'leaflet';
import { MapContainer, TileLayer, LayerGroup, Marker } from 'react-leaflet';
import GreenPinIcon from '../../assets/images/map-icons/green-pin.png';
import RedPinIcon from '../../assets/images/map-icons/red-pin.png';
import 'leaflet/dist/leaflet.css';

const centerMarker = new Icon({
  iconUrl: GreenPinIcon,
  iconSize: [32, 32],
});

const marker = new Icon({
  iconUrl: RedPinIcon,
  iconSize: [32, 32],
});

interface MapProps {
  centerMark?: any;
  marks?: any;
}

const Map: React.FC<MapProps> = ({
  centerMark = [-23.5598179, -46.638495],
  marks,
}: MapProps) => {
  return (
    <MapContainer
      center={centerMark}
      zoom={17}
      attributionControl={false}
      scrollWheelZoom={false}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <LayerGroup>
        <Marker riseOnHover position={centerMark} icon={centerMarker} />
        {marks?.map((mark: any, index: number) => (
          <Marker riseOnHover position={mark} icon={marker} key={index} />
        ))}
      </LayerGroup>
    </MapContainer>
  );
};

export default Map;
